import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import ACFLink from './../ACFLink';
import Container from './../Container';
import css from 'css';

class DescriptiveLinks extends Component {

    constructor() {
        super();

        this.state = {

        }
    }

    render() {
        const { data } = this.props;

        //console.log('DescriptiveLinks:',data);

        return(
            <ModuleWrapper background={data.background}>
                <Container>
                    {data.links.map((item, i) => {
                        return (
                            <Item key={i}>
                                <h6>{item.title}</h6>
                                <p>{item.description}</p>
                                <ACFLink data={item.link} />
                            </Item>
                        )
                    })}
                </Container>
            </ModuleWrapper>
        );
    }
}

export default withRouter(DescriptiveLinks);

const ModuleWrapper = styled.div`
    background-color: ${props => props.background === 'white' ? '#fff' : css.colors.gray};
    > div {
        display:flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding-top:70px;
        padding-bottom: 70px;
        @media (max-width: 768px) {
            padding-top:30px;
            padding-bottom: 30px;
        }
    }
`

const Item = styled.div`
    width: 20%;
    h6 {
        font-size:24px;
        font-family: ${css.fonts.bg_bold};
        margin: 0 0 20px;
        @media (max-width: 768px) {
            margin-bottom:15px;
            font-size:20px;
        }
    }
    p {
        margin-bottom: 20px;
        font-size:18px;
        line-height:1.5;
        font-family: ${css.fonts.bg_regular};
        @media (max-width: 768px) {
            margin-bottom:15px;
            font-size:16px;
        }
    }
    a {
        font-size: 18px;
        font-family: ${css.fonts.bg_regular};
    }

    @media (max-width: 768px) {
        width: 45%;
        margin-bottom: 30px;
        &:last-child {
            margin-bottom:0;
        }
    }
    @media (max-width: 480px) {
        width: 100%;
    }
`



// WEBPACK FOOTER //
// ./src/partials/modules/DescriptiveLinks.js